(() => {
  if (window.__pdpUpsellGuardLoaded) return;
  window.__pdpUpsellGuardLoaded = true;

  const dataEl = document.querySelector('[data-pdp-upsell-json]');
  let config = {};
  if (dataEl) {
    try {
      config = JSON.parse(dataEl.textContent || '{}');
    } catch (e) {
      config = {};
    }
  }

  function go(url) {
    let parsed;
    try {
      parsed = new URL(url, window.location.origin);
    } catch (e) {
      return;
    }
    if (parsed.origin !== window.location.origin) return;
    const path = (parsed.pathname + parsed.search + parsed.hash).replace(/[<>"']/g, '');
    if (!path.startsWith('/')) return;
    window.location.assign(path);
  }

  function homeUrl() {
    return config.homeUrl || window.Shopify?.routes?.root || '/';
  }

  let cartGuardTimer = null;
  let cartGuardRetryTimer = null;

  const BASE_SKU = '90RT02GRT01';
  const PLATINUM_SKU = '90RT02GRTP01';

  function normalizeSku(sku) {
    return String(sku || '').trim().toUpperCase();
  }

  function isPlatinumSku(sku) {
    return normalizeSku(sku) === PLATINUM_SKU;
  }

  function isBaseSku(sku) {
    return normalizeSku(sku) === BASE_SKU;
  }

  function itemLooksLikeGift(item) {
    const props = item?.properties;
    if (props && typeof props === 'object') {
      if (Object.keys(props).some((key) => /bogos|free[_-]?gift|_fg_|_gift|sca_/i.test(String(key)))) {
        return true;
      }
    }
    if (/sca_clone|freegift|free-gift|bogos/i.test(String(item?.handle || ''))) return true;
    if (/papermint/i.test(String(item?.handle || item?.product_title || item?.title || ''))) return true;
    const discounts = item?.discounts;
    if (Array.isArray(discounts) && discounts.some((d) => /bogos|free gift|gift/i.test(String(d?.title || '')))) {
      return true;
    }
    return false;
  }

  function rowIsRealMain(row) {
    if (!row) return false;
    if (row.dataset.appGift === 'true') return false;
    if (/papermint/i.test(String(row.dataset.productHandle || ''))) return false;
    return isBaseSku(row.dataset.sku) || isPlatinumSku(row.dataset.sku);
  }

  function itemIsMain(item) {
    if (itemLooksLikeGift(item)) return false;
    return isBaseSku(item?.sku) || isPlatinumSku(item?.sku);
  }

  function emptyCart() {
    if (window.__pdpUpgradeReplacing) return;
    window.__pdpUpsellClearing = true;
    const clearUrl = window.Theme?.routes?.cart_clear_url || `${window.Theme?.routes?.cart_url || '/cart'}/clear.js`;

    const clear = () =>
      fetch(clearUrl, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });

    clear()
      .then(() => new Promise((resolve) => window.setTimeout(resolve, 300)))
      .then(() => clear())
      .finally(() => {
        try {
          sessionStorage.setItem(
            'cart-count',
            JSON.stringify({
              value: '0',
              timestamp: Date.now(),
            })
          );
        } catch (_) {
          // no-op
        }

        document.querySelectorAll('cart-icon').forEach((icon) => {
          if (typeof icon.renderCartBubble === 'function') {
            icon.renderCartBubble(0, false);
          }
        });

        if (config.offerFlowOnly) {
          go(homeUrl());
          return;
        }
        window.location.reload();
      });
  }

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const button = target.closest('.cart-items__remove');
      if (!button) return;
      if (!rowIsRealMain(button.closest('[data-key][data-offer-flow-only]'))) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      emptyCart();
    },
    true
  );

  document.addEventListener('quantity-selector:update', (event) => {
    if (Number(event.detail?.quantity) !== 0) return;
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (!rowIsRealMain(target.closest('[data-key][data-offer-flow-only]'))) return;
    emptyCart();
  });

  function cartJsUrl() {
    const base = window.Theme?.routes?.cart_url || '/cart';
    return base.endsWith('.js') ? base : `${base}.js`;
  }

  function fetchCartItems() {
    return fetch(`${cartJsUrl()}?t=${Date.now()}`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
    })
      .then((response) => response.json())
      .then((cart) => (Array.isArray(cart.items) ? cart.items : []));
  }

  function cartPageHasRealMain() {
    return [...document.querySelectorAll('[data-key][data-offer-flow-only]')].some(rowIsRealMain);
  }

  function maybeEmptyCartAfterMainRemoved() {
    if (window.__pdpUpgradeReplacing || window.__pdpUpsellClearing) return;

    fetchCartItems()
      .then((items) => {
        if (window.__pdpUpsellClearing || window.__pdpUpgradeReplacing) return;

        const remaining = items.filter((item) => Number(item.quantity) > 0);
        if (remaining.length === 0) return;
        if (remaining.some(itemIsMain)) return;
        emptyCart();
      })
      .catch((error) => {
        console.warn('[pdp-upsell] cart guard fetch failed:', error);
      });
  }

  function scheduleCartGuardCheck() {
    if (window.__pdpUpgradeReplacing || window.__pdpUpsellClearing) return;
    window.clearTimeout(cartGuardTimer);
    window.clearTimeout(cartGuardRetryTimer);
    cartGuardTimer = window.setTimeout(() => {
      maybeEmptyCartAfterMainRemoved();
    }, 350);
    cartGuardRetryTimer = window.setTimeout(() => {
      if (window.__pdpUpsellClearing) return;
      maybeEmptyCartAfterMainRemoved();
    }, 1400);
  }

  function onCartGuardEvent(event) {
    if (window.__pdpUpgradeReplacing || window.__pdpUpsellClearing) return;
    if (event.context === 'product') return;
    if (event.action === 'add') return;

    const schedule = () => scheduleCartGuardCheck();
    if (event.promise && typeof event.promise.then === 'function') {
      event.promise.then(schedule).catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[pdp-upsell] cart guard rejected:', error);
      });
      return;
    }

    schedule();
  }

  function cartChangeUrl() {
    const route = window.Theme?.routes?.cart_change_url || '/cart/change.js';
    return route.endsWith('.js') ? route : `${route}.js`;
  }

  function removeBaseLines(lines) {
    return lines.reduce(
      (chain, item) =>
        chain.then(() =>
          fetch(cartChangeUrl(), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            credentials: 'same-origin',
            body: JSON.stringify({ id: item.key, quantity: 0 }),
          })
        ),
      Promise.resolve()
    );
  }

  function replaceBaseWhenPlatinumInCart() {
    if (window.__pdpUpgradeReplacing || window.__pdpUpsellClearing) return;
    if (sessionStorage.getItem('pdp-base-sku-removal') === 'failed') return;

    fetchCartItems()
      .then((items) => {
        const active = items.filter((item) => Number(item.quantity) > 0);
        const hasPlatinum = active.some((item) => isPlatinumSku(item.sku));
        const baseLines = active.filter((item) => isBaseSku(item.sku) && item.key);
        if (!hasPlatinum || !baseLines.length) {
          sessionStorage.removeItem('pdp-base-sku-removal');
          return null;
        }
        window.__pdpUpgradeReplacing = true;
        return removeBaseLines(baseLines).then(() => fetchCartItems());
      })
      .then((updated) => {
        if (!updated) return;
        const stillThere = updated.some((item) => isBaseSku(item.sku) && Number(item.quantity) > 0);
        if (stillThere) {
          sessionStorage.setItem('pdp-base-sku-removal', 'failed');
          window.__pdpUpgradeReplacing = false;
          return;
        }
        sessionStorage.removeItem('pdp-base-sku-removal');
        const count = updated.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
        try {
          sessionStorage.setItem(
            'cart-count',
            JSON.stringify({
              value: String(count),
              timestamp: Date.now(),
            })
          );
        } catch (_) {
          // no-op
        }
        window.location.reload();
      })
      .catch((error) => {
        window.__pdpUpgradeReplacing = false;
        sessionStorage.setItem('pdp-base-sku-removal', 'failed');
        console.warn('[pdp-upsell] base SKU was not removed:', error);
      });
  }

  document.addEventListener('shopify:cart:lines-update', onCartGuardEvent);
  document.addEventListener('cart:update', onCartGuardEvent);

  if (document.querySelector('[data-key][data-offer-flow-only]') && !cartPageHasRealMain()) {
    emptyCart();
  }

  replaceBaseWhenPlatinumInCart();
})();
